module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_txt01_01-3bfdbbdc515391b38422df7f90e66c67.webp";